import { Card, Descriptions, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import "./Profile.css";
import {
  getEmployeeDetailApi,
  getEmployeeDetailApi2,
} from "../../../Services/EmployeeOnboarding";

export default function Profile() {
  // const { profileData } = useOutletContext();
  const [profileData, setProfileData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const type = sessionStorage.getItem("userType");
  const id = sessionStorage.getItem("userId");

  const fetchEmployeeDetail = async () => {
    console.log("hellow", type);
    let data = {};

    if (type) {
      try {
        setIsLoading(true);
        if (type === "admin") {
          data = await getEmployeeDetailApi2(id);
        } else {
          data = await getEmployeeDetailApi();
        }
        setIsLoading(false);
        console.log(data?.data?.data, "checkingdata");

        if (data?.data?.success) {
          setProfileData(data?.data?.data);
          // api.success({
          //   message: data?.data?.message,
          //   placement: "top",
          // });
          // return;
        } else {
        }
      } catch (error) {
        // api.error({
        //   message: error.message || "Network error",
        //   placement: "top",
        // });
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchEmployeeDetail();
  }, []);

  return (
    <>
      {!isLoading && (
        <>
          <Card className="box-shadow mb-3">
            {profileData ? (
              <Descriptions
                title={<span className="fs-4">PERSONAL DETAILS</span>}
                layout="horizontal"
                labelStyle={
                  window.innerWidth > 991
                    ? {
                        fontSize: "18px",
                        width: "200px",
                        display: "flex",
                        justifyContent: "end",
                        paddingRight: "24px",
                        textAlign: "right",
                      }
                    : { fontSize: "18px", width: "120px" }
                }
                contentStyle={{ fontSize: "16px", paddingRight: "24px" }}
                column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
              >
                <Descriptions.Item label="Employee ID">
                  {profileData?.employee_id ? profileData?.employee_id : "--"}
                </Descriptions.Item>
                <Descriptions.Item label="Name">
                  {profileData?.name &&
                    Object.values(profileData?.name)
                      .join(" ")
                      .replace(/\s+/g, " ")}
                </Descriptions.Item>
                <Descriptions.Item label="Personal Email">
                  {profileData?.email?.personal
                    ? profileData?.email?.personal
                    : "--"}
                </Descriptions.Item>

                <Descriptions.Item label="Mobile Number">
                  {profileData?.mobile ? profileData?.mobile : "--"}
                </Descriptions.Item>
                <Descriptions.Item label="Age">
                  {profileData?.age ? profileData?.age : "--"}
                </Descriptions.Item>
                <Descriptions.Item label="DOB">
                  {profileData?.birth?.dob
                    ? profileData?.birth?.dob?.split(" ")?.[0]
                    : "--"}
                </Descriptions.Item>

                <Descriptions.Item label="Aadhar Number">
                  {profileData?.id_cards?.aadhar_number
                    ? profileData?.id_cards?.aadhar_number
                    : "--"}
                </Descriptions.Item>
                <Descriptions.Item label="Pan Number">
                  {profileData?.id_cards?.pan_number
                    ? profileData?.id_cards?.pan_number
                    : "--"}
                </Descriptions.Item>
              </Descriptions>
            ) : (
              <Skeleton active />
            )}
          </Card>
          <Card className="box-shadow mb-3">
            {profileData ? (
              <Descriptions
                title={<span className="fs-4">PROFESSIONAL DETAILS</span>}
                layout="horizontal"
                labelStyle={
                  window.innerWidth > 991
                    ? {
                        fontSize: "18px",
                        width: "200px",
                        display: "flex",
                        justifyContent: "end",
                        paddingRight: "24px",
                        textAlign: "right",
                      }
                    : { fontSize: "18px", width: "120px" }
                }
                contentStyle={{ fontSize: "16px", paddingRight: "24px" }}
                column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
              >
                <Descriptions.Item label="Reporting Manager">
                  {profileData?.reporting_manager?.name &&
                    Object.values(profileData?.reporting_manager?.name)
                      .join(" ")
                      .replace(/\s+/g, " ")}
                </Descriptions.Item>
                <Descriptions.Item label="Company Email">
                  {profileData?.email?.company
                    ? profileData?.email?.company
                    : "--"}
                </Descriptions.Item>
                <Descriptions.Item label="Date of Joining">
                  {profileData?.date_of_joining
                    ? profileData?.date_of_joining?.split(" ")?.[0]
                    : "--"}
                </Descriptions.Item>

                <Descriptions.Item label="Company">
                  {profileData?.company ? profileData?.company : "--"}
                </Descriptions.Item>
                <Descriptions.Item label="Business Unit">
                  {profileData?.business_unit
                    ? profileData?.business_unit
                    : "--"}
                </Descriptions.Item>
                <Descriptions.Item label="Function">
                  {profileData?.function ? profileData?.function : "--"}
                </Descriptions.Item>

                <Descriptions.Item label="Designation">
                  {profileData?.designation ? profileData?.designation : "--"}
                </Descriptions.Item>
                <Descriptions.Item label="Corporate">
                  {profileData?.location?.corporate
                    ? profileData?.location?.corporate
                    : "--"}
                </Descriptions.Item>
                <Descriptions.Item label="Office">
                  {profileData?.location?.office
                    ? profileData?.location?.office
                    : "--"}
                </Descriptions.Item>

                {profileData?.onboarding_id && (
                  <Descriptions.Item label="Onboarding ID">
                    {profileData?.onboarding_id}
                  </Descriptions.Item>
                )}
              </Descriptions>
            ) : (
              <Skeleton active />
            )}
          </Card>
        </>
      )}
    </>
  );
}
